import { BodyText, Button } from "@/components/ui";
import { Accordion } from "@/components/ui/Accordion/Accordion";
import { Check, Plus } from "lucide-react";
import type { RxRecommendation } from "./types";

interface SuggestionGroupProps {
  baseName: string;
  suggestions: RxRecommendation[];
  onAdd: (suggestion: RxRecommendation) => void;
  addingDrugCode: string | null;
  isAlreadyAdded: (suggestion: RxRecommendation) => boolean;
}

export const SuggestionGroup = ({
  baseName,
  suggestions,
  onAdd,
  addingDrugCode,
  isAlreadyAdded,
}: SuggestionGroupProps) => {
  // Use the order sentence from the first item — assumed same across the group
  const orderSentence = suggestions[0]?.orderSentence;
  const details = [
    orderSentence?.dispenseQuantity != null
      ? `${orderSentence.dispenseQuantity} Qty`
      : null,
    orderSentence?.daysSupply != null
      ? `${orderSentence.daysSupply} Day Supply`
      : null,
    orderSentence?.refills != null ? `${orderSentence.refills} RF` : null,
  ]
    .filter(Boolean)
    .join(", ");

  return (
    <Accordion
      accordionTitleText={baseName}
      defaultExpanded
      rightChevron
      compact
      onClick={() => {}}
      accordionBody={
        <div className="flex flex-col gap-1.5 ml-7 pb-2">
          {details && <BodyText size="sm">{details}</BodyText>}
          <div className="flex flex-wrap gap-2">
            {suggestions.map((suggestion) => {
              const drugCode = suggestion.drugCodes?.[0]?.code;
              const alreadyAdded = isAlreadyAdded(suggestion);
              const adding = addingDrugCode === drugCode;
              return (
                <Button
                  key={drugCode ?? suggestion.medicationName}
                  size="xs"
                  variant="secondary"
                  className="border-ai text-superclinical"
                  leftIcon={alreadyAdded ? Check : Plus}
                  isLoading={adding}
                  onClick={() => onAdd(suggestion)}
                  disabled={alreadyAdded || adding}
                >
                  {suggestion.strength}
                </Button>
              );
            })}
          </div>
        </div>
      }
    />
  );
};
